export default [
    {
      path: '/rent/v2/vehicle-detail',
      name: 'vehicleDetail',
      component: () => import('@/pages/vehicle/vehicleDetail'),
      meta: { title: '车辆详情', requireAuth: true },
    },
    {
      path: '/rent/v2/vehicle-reservation',
      name: 'vehicleReservation',
      component: () => import('@/pages/vehicle/vehicleReservation'),
      meta: { title: '车辆预定', requireAuth: true },
    },
    {
      path: '/rent/v2/preferential-car-rental',
      name: 'preferentialCarRental',
      component: () => import('@/pages/vehicle/preferentialCarRental'),
      meta: { title: '特惠租车', requireAuth: true },
    },
    {
      path: '/rent/v2/vehicle-evaluate',
      name: 'orderEvaluate',
      component: () => import('@/pages/vehicle/evaluate'),
      meta: { title: '更多评价', requireAuth: true },
    }
  ]



// WEBPACK FOOTER //
// ./src/pages/vehicle/vehicle.js